import Markdoc, { Schema } from "@markdoc/markdoc";

export const zipFileExtractionNotice: Schema = {
  render: "ZipFileExtractionNotice",
  selfClosing: true,
  transform() {
    return new Markdoc.Tag("ZipFileExtractionNotice");
  },
};
